const initialState = {
    isLoading: false,
    pageLoadedOnce: false,
    noLocalPlayers: false,
    noLocalEvents: false,
    noLocalColleges: false,
    noLocalHighSchools: false,
    players: {
        hits: [],
    },
    events: {
        hits: [],
    },
    flexLeagues: {
        hits: [],
    },
    teamLeagues: {
        hits: [],
    },
    proTennisTour: {
        hits: [],
    },
    clubs: {
        hits: [],
    },
    colleges: {
        hits: [],
    },
    highSchools: {
        hits: [],
    },
    paidHits: {
        hits: [],
    },
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'EXPLORE:LOAD_PLAYERS_REQUEST': {
            return {
                ...state,
                players: {
                    hits: [],
                },
                total: 0,
                isLoading: true,
            };
        }
        case 'EXPLORE:LOAD_EVENTS_REQUEST': {
            return {
                ...state,
                events: {
                    hits: [],
                },
                total: 0,
                isLoading: true,
            };
        }
        case 'EXPLORE:LOAD_COLLEGES_REQUEST': {
            return {
                ...state,
                colleges: {
                    hits: [],
                },
                total: 0,
                isLoading: true,
            };
        }
        case 'EXPLORE:LOAD_HIGH_SCHOOLS_REQUEST': {
            return {
                ...state,
                highSchools: {
                    hits: [],
                },
                total: 0,
                isLoading: true,
            };
        }

        case 'EXPLORE:LOAD_PLAYERS_SUCCESS':
            return {
                ...state,
                players: {
                    ...state.players,
                    hits: [
                        ...action.data.hits,
                    ],
                    total: action.data.total,
                },
                isLoading: false,
            };
        case 'EXPLORE:LOAD_EVENTS_SUCCESS':
            return {
                ...state,
                events: {
                    ...state.events,
                    hits: [
                        ...action.data.hits,
                    ],
                    total: action.data.total,
                },
                isLoading: false,
            };

        case 'EXPLORE:LOAD_COLLEGES_SUCCESS':
            return {
                ...state,
                colleges: {
                    ...state.colleges,
                    hits: [
                        ...action.data.hits,
                    ],
                    total: action.data.total,
                },
                isLoading: false,
            };
        case 'EXPLORE:LOAD_HIGH_SCHOOLS_SUCCESS':
            return {
                ...state,
                highSchools: {
                    ...state.highSchools,
                    hits: [
                        ...action.data.hits,
                    ],
                    total: action.data.total,
                },
                isLoading: false,
            };

        case 'EXPLORE:LOAD_PLAYERS_FAILURE':
        case 'EXPLORE:LOAD_CLUBS_FAILURE':
        case 'EXPLORE:LOAD_EVENTS_FAILURE':
        case 'EXPLORE:LOAD_HIGHSCHOOLS_FAILURE':
        case 'EXPLORE:LOAD_COLLEGES_FAILURE':
            return {
                ...state,
                isLoading: false,
            };

        case 'EXPLORE:NO_LOCAL_PLAYERS':
            return {
                ...state,
                noLocalPlayers: action.noLocalPlayers,
            };
        case 'EXPLORE:NO_LOCAL_EVENTS':
            return {
                ...state,
                noLocalEvents: action.noLocalEvents,
            };
        case 'EXPLORE:NO_LOCAL_COLLEGES':
            return {
                ...state,
                noLocalColleges: action.noLocalColleges,
            };
        case 'EXPLORE:NO_LOCAL_HIGH_SCHOOLS':
            return {
                ...state,
                noLocalHighSchools: action.noLocalHighSchools,
            };

        default:
            return state;
    }
}

export default app;
